import { combineReducers } from 'redux'
import fetchReducer from './fetchReducer'
import resourceBundleReducer from './resourceBundleReducer'
import formReducer from './formReducer'
import nextSubmitReducer from './nextSubmitReducer'
import pageSubmitReducer from './pageSubmitReducer'
import getTemplatePropertiesReducer from './getTemplatePropertiesReducer'
import paginationReducer from './paginationReducer'
import rowsPerPageOptionReducer from './rowsPerPageOptionReducer'
import loginFormReducer from './loginFormReducer'
import logOutReducer from './logOutReducer'
// import solrPaginationReducer from './solrPaginationReducer'
// import solrFacetReducer from './solrFacetReducer'
import getUrlMappingsReducer from './getUrlMappingsReducer'
import getLoaderStatusReducer from './getLoaderStatusReducer'
import getLoginStatusReducer from './getLoginStatusReducer'
import getCartUpdatedStatusReducer from './getCartUpdatedStatusReducer'
import getProfileDetailsReducer from './getProfileDetailsReducer'
import updateAddToCartReducer from './updateAddToCartReducer'
import miniCartItemCountReducer from './miniCartItemCountReducer'
import forgotPaswordMsgReducer from './forgotPaswordMsgReducer'
import updateProfileDetailsReducer from './updateProfileDetailsReducer'
import mergeCartReducer from './mergeCartReducer'
import commerceItemDetailsReducer from './commerceItemDetailsReducer'
import getOrganizationDetailsReducer from './getOrganizationDetailsReducer'
import getShoppingListDetailsReducer from './getShoppingListDetailsReducer'
import registerMsgReducer from './registerMsgReducer'
import redirectUrlReducer from './redirectUrlReducer'
import updateShoppingListDetailsReducer from './updateShoppingListDetailsReducer'
import CheckOutHeaderOptionsReducer from './CheckOutHeaderOptionsReducer'
import getSearchValueReducer from './getSearchValueReducer'
import GetCartDetailsReducer from './GetCartDetailsReducer'
import getProfileDetailsDataReducer from './getProfileDetailsDataReducer'
import GetBlogPageThemeReducer from './GetBlogPageThemeReducer'
import updateMiniCartReducer from './updateMiniCartReducer'
import getAddToListDetailsReducer from './getAddToListDetailsReducer'
import getIncludeQuickViewAddToCartProductDetailsReducer from './getIncludeQuickViewAddToCartProductDetailsReducer'
import getMiniCartDetailsReducer from './getMiniCartDetailsReducer'
import getUpdateMiniCartFlagReducer from './getUpdateMiniCartFlagReducer'
import monetateDetailsReducer from './monetateDetailsReducer'


export default combineReducers({
    fetch: fetchReducer,
    resourceBundle: resourceBundleReducer,
    form: formReducer,
    nextSubmit: nextSubmitReducer,
    pageSubmit: pageSubmitReducer,
    getTemplateProperties: getTemplatePropertiesReducer,
    tablePagination: paginationReducer,
    tablerowsPerPage: rowsPerPageOptionReducer,
    loginForm: loginFormReducer,
    logOut: logOutReducer,
    getUrlMappings: getUrlMappingsReducer,
    getLoaderStatus: getLoaderStatusReducer,
    getLoginStatus: getLoginStatusReducer,
    getCartUpdatedStatus: getCartUpdatedStatusReducer,
    getProfileDetails: getProfileDetailsReducer,
    updateAddToCart: updateAddToCartReducer,
    miniCartItemCountReducer:miniCartItemCountReducer,
    forgotPasswordMsgReducer:forgotPaswordMsgReducer,
    registerMsgReducer:registerMsgReducer,
    updateProfileDetailsReducer:updateProfileDetailsReducer,
    mergeCartReducer:mergeCartReducer,
    commerceItemDetailsReducer:commerceItemDetailsReducer,
    getOrganizationDetails:getOrganizationDetailsReducer,
    getShoppingListDetails:getShoppingListDetailsReducer,
    redirectUrlReducer:redirectUrlReducer,
    updateShoppingListDetailsReducer:updateShoppingListDetailsReducer,
    checkOutHeaderOptions : CheckOutHeaderOptionsReducer,
    getSearchValue:getSearchValueReducer,
    getCartDetails:GetCartDetailsReducer,
    getProfileDetailsData : getProfileDetailsDataReducer,
    GetBlogPageThemeReducer :GetBlogPageThemeReducer,
    updateMiniCartReducer:updateMiniCartReducer,
    addToListDetails : getAddToListDetailsReducer,
    includeQuickViewAddToCartDetails : getIncludeQuickViewAddToCartProductDetailsReducer,
    getMiniCartDetails : getMiniCartDetailsReducer,
    getUpdateMiniCartFlag : getUpdateMiniCartFlagReducer,
    getMonetateDetails : monetateDetailsReducer
})
